module.exports = __webpack_public_path__ + "img/main_logo.66ad9846.gif";